import { orderBy } from 'lodash-es'

const gatewayAlarmTypes = orderBy([
  {
    value: 'CONNECTION',
    text: 'CONNECTION FALSE'
  }, {
    value: 'CPU',
    text: 'CPU'
  }, {
    value: 'DOOR',
    text: 'DOOR OPEN'
  }, {
    value: 'GPS',
    text: 'GPS UNLOCKED'
  }, {
    value: 'POWER_LOST',
    text: 'POWER LOST'
  }, {
    value: 'RAM',
    text: 'RAM'
  }, {
    value: 'RSSI',
    text: 'RSSI'
  }, {
    value: 'SHUTDOWN',
    text: 'SHUTDOWN'
  }, {
    value: 'SYSTEM_DISK',
    text: 'SYSTEM DISK'
  }, {
    value: 'TEMPERATURE',
    text: 'TEMPERATURE'
  }, {
    value: 'USER_DISK',
    text: 'USER DISK'
  }
], ['text'])

const networkAlarmTypes = orderBy([
  {
    value: 'FRQ_DUTY_CYCLE',
    text: 'FRQ DUTY CYCLE'
  }
], ['text'])

const endDeviceAlarmTypes = orderBy([
  {
    value: 'JOIN_SUCCESS',
    text: 'JOIN SUCCESS',
    type: 'notification'
  }, {
    value: 'JOIN_MIC_ERR',
    text: 'JOIN MIC ERR',
    type: 'alarm'
  }, {
    value: 'JOIN_DEVNONCE_ERR',
    text: 'JOIN DEVNONCE ERR',
    type: 'alarm'
  }, {
    value: 'JOIN_DEVADDR_ERR',
    text: 'JOIN DEVADDR ERR',
    type: 'alarm'
  }, {
    value: 'JOIN_APPEUI_ERR',
    text: 'JOIN APPEUI ERR',
    type: 'alarm'
  }, {
    value: 'DATAUP_SUCCESS',
    text: 'DATAUP SUCCESS',
    type: 'notification'
  }, {
    value: 'DATAUP_MIC_ERR',
    text: 'DATAUP MIC ERR',
    type: 'alarm'
  }, {
    value: 'DATADOWN_FCNTDOWN_CHANGED',
    text: 'DATADOWN FCNTDOWN CHANGED',
    type: 'alarm'
  }, {
    value: 'DATADOWN_FCNTDOWN_ERR',
    text: 'DATADOWN FCNTDOWN ERR',
    type: 'alarm'
  }, {
    value: 'DATADOWN_TIMEOUT',
    text: 'DATADOWN TIMEOUT',
    type: 'alarm'
  }, {
    value: 'DATADOWN_MAXATTEMPTS',
    text: 'DATADOWN MAXATTEMPTS',
    type: 'alarm'
  }, {
    value: 'DATADOWN_GW_NACK',
    text: 'DATADOWN GW NACK',
    type: 'alarm'
  }, {
    value: 'DOWNLINK_UNABLE_TO_SEND',
    text: 'DOWNLINK UNABLE TO SEND',
    type: 'alarm'
  }, {
    value: 'PUSH_TIMEOUT',
    text: 'PUSH TIMEOUT',
    type: 'alarm'
  }, {
    value: 'PUSH_AUTH_FAILED',
    text: 'PUSH AUTH FAILED',
    type: 'alarm'
  }, {
    value: 'PUSH_NOT_FOUND',
    text: 'PUSH NOT FOUND',
    type: 'alarm'
  }, {
    value: 'PUSH_SERVER_ERR',
    text: 'PUSH SERVER ERR',
    type: 'alarm'
  }
], ['text'])

// Export all by default
export default {
  gatewayAlarmTypes,
  networkAlarmTypes,
  endDeviceAlarmTypes
}

// Export separate modules
export { gatewayAlarmTypes }
export { networkAlarmTypes }
export { endDeviceAlarmTypes }
